import { useQuery } from 'react-query'
import { Shop } from '../../types'
import { logFactory } from '../../util/logFactory'
import { useAppointmentsService } from '../services'

const hookName = 'useShopBySalesforceId'
const log = logFactory(hookName)

const useShopBySalesforceId = (shopSalesforceId?: string) => {
  const { getShops, isReady } = useAppointmentsService()

  const fetchShop = async (): Promise<Shop | null> => {
    if (!shopSalesforceId || !isReady) return null

    log(`🏛️ Fetching shop by salesforce id...`, { shopSalesforceId })

    const { data: shops } = await getShops({ gid: shopSalesforceId, page_size: 1 })
    const shop = shops[0] || null

    log(`🏛️ Found shop`, shop)

    return shop
  }

  return useQuery([hookName, shopSalesforceId], fetchShop, {
    enabled: Boolean(shopSalesforceId && isReady),
  })
}

export { useShopBySalesforceId }
